export default "__VITE_ASSET__7f40751f__"